import { c as _c } from "react/compiler-runtime";
import Grid from '@precis-digital/kurama/Grid';
import Typography from '@precis-digital/kurama/Typography';
import { useTheme } from '@precis-digital/kurama/utils';
import ThemedImage from 'shared/components/Themed/Image';
import settingsIcon from 'public/assets/images/settings.svg';
interface NoDataProps {
  title: string;
  body: string;
}
const NoData: React.FC<NoDataProps> = t0 => {
  const $ = _c(16);
  const {
    title,
    body
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== theme) {
    t1 = theme.spacing(3);
    $[0] = theme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== theme) {
    t2 = theme.spacing(5);
    $[2] = theme;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ThemedImage src={settingsIcon.src} alt="settings" width={335} height={169} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== title) {
    t4 = <Typography variant="h5">{title}</Typography>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== body) {
    t5 = <Typography variant="body3">{body}</Typography>;
    $[7] = body;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <Grid container={true} direction="column" alignItems="center" maxWidth={400} textAlign="center">{t4}{t5}</Grid>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t6) {
    t7 = <Grid container={true} direction="column" alignItems="center" justifyContent="center" paddingTop={t1} gap={t2}>{t3}{t6}</Grid>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default NoData;